import base from './base'

export default {
  // 手机短信验证码登录
  loginBySms(params) {
    return base.post('/user/login/login', params)
  },

}
